export enum DashboardCardState {
  LOADED,
  NOT_LOADED,
  STALE
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/dashboard/dashboard-card-state.ts